import React from "react";
import { NavLink } from "react-router-dom";
import AllPlayer from "./AllPlayer";

const Registration = () => {
  return (
    <div className="relative flex flex-col items-center min-h-screen bg-gradient-to-br from-purple-900 via-gray-900 to-black text-white p-2 overflow-hidden">
      {/* Background Glow Effect */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-purple-600/30 blur-3xl rounded-full"></div>
        <div className="absolute bottom-20 right-10 w-72 h-72 bg-pink-600/30 blur-3xl rounded-full"></div>
      </div>

      {/* Header */}
      <div className="relative text-center z-10 my-6">
        <h3 className="text-2xl sm:text-3xl font-bold uppercase tracking-wide text-gray-200 drop-shadow-lg">
          Bargaon Premier League 🏏
        </h3>
        {/* <h1 className="text-4xl sm:text-6xl font-extrabold my-4 bg-gradient-to-r from-yellow-400 to-red-500 bg-clip-text text-transparent drop-shadow-md animate-pulse">
          Registration Open!
        </h1>
        <NavLink
          to={"/form"}
          className="inline-block px-6 py-3 mt-4 text-lg sm:text-xl font-bold bg-gradient-to-r from-green-400 via-blue-500 to-purple-600 text-white rounded-full shadow-lg hover:scale-105 hover:from-pink-500 hover:to-red-500 transition-all duration-300"
        >
          👉 Click Here to Register 🔗
        </NavLink> */}
      </div>

      {/* Divider */}
      <div className="relative w-full flex justify-center z-10 my-6">
        <hr className="border-gray-500 md:w-1/2 w-3/4" />
      </div>

      {/* Organisers Section */}
      <div className="relative w-full flex justify-center px-2 my-6 z-10">
        <div className="max-w-2xl w-full bg-white/10 backdrop-blur-lg shadow-2xl rounded-2xl p-4 border border-white/20">
          <h3 className="text-2xl font-bold text-center text-gray-100 mb-6 uppercase tracking-wide">
            Organisers
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl p-4 text-center font-semibold shadow-lg hover:scale-105 transition">
              MANNU YADAV
            </div>
            <div className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-xl p-4 text-center font-semibold shadow-lg hover:scale-105 transition">
              SAILESH GIRI
            </div>
            <div className="bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-xl p-4 text-center font-semibold shadow-lg hover:scale-105 transition">
              NIGAM GOND
            </div>
            <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-xl p-4 text-center font-semibold shadow-lg hover:scale-105 transition">
              RAHUL GIRI
            </div>
          </div>
          <h3 className="text-lg sm:text-xl font-medium text-center text-gray-300 mt-6">
            📞 Contact Us :{" "}
            <a
              href="tel:+91-9199274812"
              className="text-yellow-400 font-semibold hover:underline"
            >
              +91 91992 74812
            </a>
          </h3>
        </div>
      </div>

      {/* Divider */}
      <div className="relative w-full flex justify-center z-10 my-6">
        <hr className="border-gray-500 md:w-2/3 w-5/6" />
      </div>

      {/* Player Section */}
      <div className="relative w-full z-10">
        <AllPlayer />
      </div>
    </div>
  );
};

export default Registration;
